import { useSearchGasConsumptionsQuery } from "./gasConsumptionApi";
import useTranslator from "../../../../hooks/useTranslator";
import Datatable from "../../../../components/shared/datatable/Datatable";
import { useEffect, useState } from "react";
import { PlusSvg } from "../../../../svgFiles/PlusSvg";
import GasConsumptionModal from "./GasConsumptionModal";
import { EditSvg } from "../../../../svgFiles/EditSvg";
import { convertToUserTimezone } from "../../../../helpers/Utils";

const GasConsumption = () => {
  const { _t } = useTranslator();

  // States
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [modalMode, setModalMode] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({ date: "" });

  const handleFilterApply = (newFilters) => {
    setAppliedFilters(newFilters);
    setFilter(newFilters);
  };

  // RTK Queries
  const { data: records ,isLoading : isGasLoading ,isFetching : isGasFetching } = useSearchGasConsumptionsQuery({ page, ...filter });

  useEffect(() => {
    setPage(1);
  }, [filter]);

  // Columns
  const gasConsumptionColumns = [
    // {
    //   label: _t("group_id", "Group ID"),
    //   accessor: "group_id",
    // },
    {
      label: _t("date", "Date"),
      cell: ({ row }) =>{
        return row.entered_date_time ? convertToUserTimezone(row.entered_date_time) : "";
      }        
    },
    {
      label: _t("fc", "FC"),
      accessor: "fc",
    },
    {
      label: _t("m3_consumed", "Total M3 Consumed"),
      accessor: "total_m3_consumed",
    },
    {
      label: _t("liter_consumed", "Total Liter Consumed"),
      accessor: "total_liters_consumed",
    },
    {
      label: _t("price_per_l", "Price Per L"),
      accessor: "price_per_l",
    },
    {
      label: _t("total_cost", "Total Cost"),
      accessor: "total_group_cost",
    },
    {
      label: _t("actions", "Actions"),
      accessor: "actions",
      cell: ({ row }) => (
        <>
          <span
            className="cursor-pointer pe-2"
            onClick={() => handleEditGasConsumptionData(row)}
          >
            <EditSvg />
          </span>
        </>
      ),
    },
  ];

  // Functions
  //---------------------------------------------------------------------
  const handleAddGasConsumptionData = () => {
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };

  const handleEditGasConsumptionData = (record) => {
    setModalMode("edit");
    setSelectedRecord(record);
    setShowModal(true);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  //---------------------------------------------------------------------

  return (
    <>
      <GasConsumptionModal
        show={showModal}
        setShow={setShowModal}
        record={selectedRecord}
        mode={modalMode}
      />
        <Datatable
          title={_t("gas_consumption_log", "Gas Consumption Log")}
          columns={gasConsumptionColumns}
          tableData={records?.data}
          buttons={[
            {
              label: _t("add_gas_consumption", "Add Gas Consumption Data"),
              onClick: handleAddGasConsumptionData,
              icon: PlusSvg,
            },
          ]}
          page={page}
          onPageChange={handlePageChange}
          showCount={true}
          showPegination={true}
          showFilter={handleFilterApply}
          showFilterButton={true}
          filterModule="gas-consumption-filter"
          filters={appliedFilters}
          isLoading={isGasLoading || isGasFetching}
        />
    </>
  );
};

export default GasConsumption;
